<template>
  <div class="d-none">
    <div v-if="statements" class="pdf" id="investment-consolidated-statement-pdf">
      <div class="text-right">
        <div class="pdf-logo">
          <img src="/img/logos/logo-black.png" alt="">
        </div>
        <p>
          Station House<br>
          Station Road<br>
          London<br>
          SW13 0HT
        </p>
      </div>
      <p class="pdf-date">
        {{ $dates.getDate() }}
      </p>
      <p>
        <span class="pdf-recipient">
          {{ $auth.user.profile.title }} {{ $auth.user.profile.firstName }} {{ $auth.user.profile.middleName }} {{ $auth.user.profile.lastName }}
        </span>
        <br>
        <span class="pdf-recipient-subline">
          <formatted-address :address="$auth.user.profile.address" />
        </span>
      </p>
      <div class="pdf-divider"></div>
      <p class="pdf-title">
        Funding Statement
      </p>
      <table class="pdf-table mb-4">
        <colgroup>
          <col width="50%" />
          <col width="50%" />
        </colgroup>
        <tr>
          <th>Amount Funded</th>
          <td>{{ $formatting.toCurrency(getAmountFunded) }}</td>
        </tr>
        <tr>
          <th>Amount Repaid</th>
          <td>{{ $formatting.toCurrency(getAmountRepaid) }}</td>
        </tr>
        <tr>
          <th>Balance Deployed</th>
          <td>{{ $formatting.toCurrency(getBalanceDeployed) }}</td>
        </tr>
        <tr>
          <th>Total Interest to Date</th>
          <td>{{ $formatting.toCurrency(getTotalInterestToDate) }}</td>
        </tr>
        <tr>
          <th>Total Interest Paid to Date</th>
          <td>{{ $formatting.toCurrency(getTotalInterestPaidToDate) }}</td>
        </tr>
      </table>
      <table class="pdf-table">
        <colgroup>
          <col width="14%" />
          <col width="17%" />
          <col width="17%" />
          <col width="13%" />
          <col width="13%" />
          <col width="13%" />
          <col width="13%" />
        </colgroup>
        <thead>
          <tr>
            <th>Date</th>
            <th>Loan</th>
            <th>Description</th>
            <th>Credit</th>
            <th>Debit</th>
            <th>Capital</th>
            <th>Interest Due</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(statement, key) in statements" :key="key">
            <td>{{ $dates.toDate(statement.date) }}</td>
            <td>{{ statement.investment.title }}</td>
            <td>{{ statement.type.description }}</td>
            <td>
              <template v-if="statement.credit">
                {{ $formatting.toCurrency(statement.credit) }}
              </template>
            </td>
            <td>
              <template v-if="statement.debit">
                -{{ $formatting.toCurrency(statement.debit) }}
              </template>
            </td>
            <td>
              <template v-if="statement.capital">
                {{ $formatting.toCurrency(statement.capital) }}
              </template>
            </td>
            <td>
              <template v-if="statement.interestDue">
                {{ $formatting.toCurrency(statement.interestDue) }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
      <p class="mt-3 text-center">
        Please note that this statement is provided for information purposes only and is based on the data and position
        at the time of issue. It is not a guarantee that any accrued and unpaid returns can or will be paid as these
        remain subject to investment performance until they are paid.
      </p>
    </div>
  </div>
</template>

<script>
import FormattedAddress from './FormattedAddress.vue'

export default {
  name: 'InvestmentConsolidatedStatementPdf',

  components: {
    FormattedAddress
  },

  props: {
    statements: Array,
    userInvestments: Array
  },

  computed: {
    getAmountFunded () {
      return this.$_.sumBy(this.userInvestments, 'invested')
    },

    getAmountRepaid () {
      const statements = this.statements.filter(statement => ['interest-accrued', 'redemption'].includes(statement.type.key))

      return this.$_.sumBy(statements, 'credit')
    },

    getBalanceDeployed () {
      const statements = this.statements.filter(statement => ['loan-funded'].includes(statement.type.key))

      return this.$_.sumBy(statements, 'credit')
    },

    getTotalInterestToDate () {
      return this.$_.sumBy(this.userInvestments, 'accrued')
    },

    getTotalInterestPaidToDate () {
      const statements = this.statements.filter(statement => ['interest-paid'].includes(statement.type.key))

      return this.$_.sumBy(statements, 'debit')
    }
  }
}
</script>
